import { useMutation } from "@tanstack/react-query";
import { SiteAPI } from "../api";

export const useSiteInformation = () => {
  return useMutation({
    mutationFn: () => SiteAPI.getSiteInformation(),
    onError: (error) => {
      console.error("Get Site Information Failed: ", error.response || error);
    },
  });
};
